import {
  AUTO_TABLE_CUSTOM_VALUE_ALL,
  getPlaceholderConfig,
  isCascaderMultiComponent,
} from '../../../libs';
import {
  IConfigField,
  IFieldTypeOptByCascaderMulti,
  IValue,
} from '../../../model';
import React from 'react';
import { Cascader } from 'antd';
import classNames from 'classnames';

interface IPropsCascaderMulti<T> {
  readonly fieldConfig: IConfigField<T>;
  readonly onChanged: <T>(key: string, value: T) => void;
  readonly selectedValue: IValue;
  readonly isFilterModeView: boolean;
  readonly className?: string;
}

export const DynamicCascaderMulti = <T,>(props: IPropsCascaderMulti<T>) => {
  const { isFilterModeView, fieldConfig, selectedValue } = props;
  const options = (fieldConfig?.fieldOptExtension?.data || []) as any[];
  const placeholder = getPlaceholderConfig(fieldConfig);
  const { cascaderClassName = '', popupClassName = '' } =
    fieldConfig.filterOptExtension as IFieldTypeOptByCascaderMulti;

  const getStatusBySelected = (val: any, beforeVal: Array<any>) => {
    let isSelectAll = false;
    let isCancelSelectAll = false;
    let isRemoveSelectAll = false;
    if (Array.isArray(val)) {
      // 找到所有的一级id
      const all = AUTO_TABLE_CUSTOM_VALUE_ALL;
      const selectedVal = val.flat(Infinity);
      const before = beforeVal.flat(Infinity);
      const allRootValue = options.map((v) => v.id).filter((v) => v !== all);
      const isAllRootVal = (val: Array<string>) => {
        return (
          val.length === allRootValue.length &&
          val.every((v) => allRootValue.includes(v))
        );
      };

      if (selectedVal.includes(all) && !before.includes(all)) {
        isSelectAll = true;
      }

      if (!selectedVal.includes(all) && before.includes(all)) {
        isCancelSelectAll = true;
      }

      // 选中了除去‘全部’的其他选项
      if (
        selectedVal.length === options.length - 1 &&
        !selectedVal.includes(all) &&
        isAllRootVal(selectedVal)
      ) {
        isSelectAll = true;
      }

      if (
        selectedVal.length === options.length - 1 &&
        selectedVal.includes(all) &&
        before.length === options.length
      ) {
        isRemoveSelectAll = true;
      }
    }

    return { isSelectAll, isCancelSelectAll, isRemoveSelectAll };
  };

  if (isFilterModeView) {
    const filterOptExtension = isCascaderMultiComponent(
      fieldConfig.filterOptExtension
    );
    if (!filterOptExtension) {
      return null;
    }

    const onChangedCascader = () => {
      return (val: any) => {
        let value = val;
        if (!value) {
          props.onChanged(fieldConfig.key, '');
          return;
        }
        if (!Array.isArray(value)) {
          return;
        }
        // 找到所有的一级id
        const allRootValue = options.map((v) => v.id);
        const { isSelectAll, isCancelSelectAll, isRemoveSelectAll } =
          getStatusBySelected(val, []);

        if (isSelectAll) {
          value = allRootValue.map((v) => [v]);
        }

        if (isCancelSelectAll) {
          value = [];
        }

        if (isRemoveSelectAll) {
          const index = value.findIndex(
            (v: any) =>
              Array.isArray(v) && v.includes(AUTO_TABLE_CUSTOM_VALUE_ALL)
          );
          if (index !== -1) {
            value.splice(index, 1);
          }
        }

        props.onChanged(fieldConfig.key, value);
      };
    };

    const filter = (inputValue: string, path: any) => {
      return path.some(
        (option: any) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    };
    const defaultValue = selectedValue.value || [];

    return (
      <>
        <Cascader
          value={defaultValue || []}
          style={{ minWidth: '84px' }}
          options={options || []}
          multiple={true}
          onChange={onChangedCascader()}
          placeholder={placeholder || '请选择'}
          showSearch={{ filter }}
          changeOnSelect={true}
          className={classNames('nextgamedev-cascader', cascaderClassName)}
          dropdownClassName={classNames(
            'nextgamedev-cascader-popup',
            popupClassName
          )}
        />
      </>
    );
  }

  return <span className={props.className}>{selectedValue.value}</span>;
};
